import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.sidebar = document.getElementById("sidebar")
  }

  toggleSidebar() {
    const expanded = this.element.getAttribute("aria-expanded") === "true"
    this.element.setAttribute("aria-expanded", !expanded)
    this.sidebar.classList.toggle("hidden", expanded)
  }
}
